module.exports = __webpack_public_path__ + "static/img/noticia7.74612e7b.jpg";